export default __webpack_public_path__ + "static/store-one.ko-76e8b47ea47cbf0180aa00d658f8c272.png";